import('./bootstrap');
import('./polyfill');

export {};
